// import defineRule from '../defineRule'
import { isValidPassword } from 'src/utils/validators'
import { defineRule } from 'vee-validate'

defineRule('validPassword', (password: string) => {
   return isValidPassword(`${password}`)
})
